function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect } from 'react';

/**
 * A React hook for detecting matching a media query.
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
 * @example const matches = useMatchMedia('(min-width: 768px)');
 * @param query string
 * @param defaultMatches boolean | undefined
 * @returns boolean
 */
var useMatchMedia = function useMatchMedia(query) {
  var defaultMatches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var initialMatch = typeof window === 'undefined' ? false : window.matchMedia(query).matches;
  var _useState = useState(initialMatch || defaultMatches),
    _useState2 = _slicedToArray(_useState, 2),
    matches = _useState2[0],
    setMatches = _useState2[1];
  var listener = function listener(e) {
    setMatches(e.matches);
  };
  useEffect(function () {
    var mediaQueryList = window.matchMedia(query);
    mediaQueryList.addEventListener('change', listener);
    setMatches(mediaQueryList.matches);
    return function () {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, [query]); // eslint-disable-line react-hooks/exhaustive-deps
  return matches;
};
export { useMatchMedia };